<template>
    <div>
        <b-row>
            <b-col>
                <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :columns="header" :rows="columnData" @on-row-click="onRowClick" :total-rows="pageTotal" :per-page="serverParams.perPage" :isLoading.sync="isLoading" :pagination-options="{
                    enabled: true,
                }">
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="d-flex justify-content-between flex-wrap">
                            <div class="d-flex align-items-center mb-0 mt-1">
                                <span class="text-nowrap">
                                    Showing 1 to
                                </span>
                                <b-form-select v-model="serverParams.perPage" :options="[5, 10, 20, 50, 100]" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                                <span class="text-nowrap"> of {{ props.total }} entries </span>
                            </div>

                            <b-pagination :value="1" :total-rows="pageTotal" :per-page="serverParams.perPage" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                                <template #prev-text>
                                    <feather-icon icon="ChevronLeftIcon" size="18" />
                                </template>
                                <template #next-text>
                                    <feather-icon icon="ChevronRightIcon" size="18" />
                                </template>
                            </b-pagination>
                        </div>
                    </template>
                </vue-good-table>
            </b-col>
        </b-row>
        <b-modal id="customerDetails-modal" title="Customer Details" ok-title="Ok" cancel-title="Cancel" centered>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0">Name:</h6>
                    <span>{{ modal.name }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">IC/Passport:</h6>
                    <span>{{ modal.newIC }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Address:</h6>
                    <span>{{ modal.address }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Postcode:</h6>
                    <span>{{ modal.postcode }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">State:</h6>
                    <span>{{ state }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Vehicle Plate No:</h6>
                    <span>{{ modal.vehNo }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Vehicle Type:</h6>
                    <span>{{ modal.vehClass === "01" ? "Motorcycle" : "Car" }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Vehicle CC:</h6>
                    <span>{{ modal.cc }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Vehicle Year Make:</h6>
                    <span>{{ modal.yearMake }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">NCD %:</h6>
                    <span>{{ modal.ncd }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Policy Type:</h6>
                    <span>{{ modal.policyType }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Source:</h6>
                    <span>{{ modal.source }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Last Transaction Date:</h6>
                    <span>{{ $date(modal.lastTrans, "DDMMYYYY").format("DD/MM/YYYY") }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Last Paid:</h6>
                    <span>{{ modal.lastPaid }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Vehicle Model & Variant:</h6>
                    <span>{{ modal.model }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Phone Number:</h6>
                    <span>{{ modal.mobileNo }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Email Address:</h6>
                    <span>{{ modal.email }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Expire/Renewal Date:</h6>
                    <span>{{ $date(modal.expDate, "DDMMYYYY").format("DD/MM/YYYY") }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h6 class="text-capitalize mb-0 mt-2">Agent AffiliateCode:</h6>
                    <span>{{ modal.affiliateCode }}</span>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import { getCustomers } from "@/services/AdminService";
import { BBadge, BButton, BCard, BCardBody, BCardText, BCol, BFormSelect, BModal, BPagination, BRow } from 'bootstrap-vue';
import { VueGoodTable } from "vue-good-table";
import { stateOptions } from "@/helpers/optionsHelper";

export default {
    name: "Customers",
    components: {
        BCard,
        BCardText,
        BRow,
        BCol,
        BCardBody,
        BButton,
        BModal,
        VueGoodTable,
        BPagination,
        BFormSelect,
        BBadge,
    },
    data() {
        return {
            isLoading: false,
            pageTotal: 0,
            columnData: [{}],
            modal: {},
            serverParams: {
                columnFilters: {},
                sort: [
                    {
                        field: 'createdAt',
                        type: 'desc'
                    }

                ],
                page: 1,
                perPage: 10
            }
        };
    },
    async mounted() {
        await this.loadItems();
    },
    computed: {
        state() {
            return stateOptions.find((e) => e.value === this.modal.state)?.text ?? "";
        },
        isMobile() {
            const currentBreakPoint = this.$store.getters["app/currentBreakPoint"];
            const isMobile = currentBreakPoint === "xs";
            return isMobile;
        },
        header() {
            return [
                {
                    label: "Date Added",
                    field: "createdAt",
                    type: "date",
                    dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
                    dateOutputFormat: "dd/MM/yyyy HH:mm:ss",
                },
                {
                    label: "Expire",
                    field: "expDate",
                    type: "date",
                    dateInputFormat: "ddMMyyyy",
                    dateOutputFormat: "dd/MM/yyyy",
                },
                {
                    label: "Plate No.",
                    field: "vehNo",
                    filterOptions: {
                        enabled: true
                    }
                },
                {
                    label: "Last Trans",
                    field: "lastTrans",
                    type: "date",
                    dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
                    dateOutputFormat: "dd/MM/yyyy",
                },
                {
                    label: "Past Paid",
                    field: "lastPaid",
                },
                {
                    label: "Policy Type",
                    field: "policyType",
                    hidden: this.isMobile,
                },
                {
                    label: "Vehice Type",
                    field: "vehClass",
                    formatFn: (e) => e === "01" ? "Motorcycle" : "Car",
                    hidden: this.isMobile,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [
                            {
                                text: "Motorcycle",
                                value: "01",
                            },
                            {
                                text: "Car",
                                value: "02",
                            }
                        ]
                    }
                },
                {
                    label: "Model",
                    field: "model",
                    hidden: this.isMobile,
                    filterOptions: {
                        enabled: true
                    }
                },
                {
                    label: "CC",
                    field: "cc",
                    hidden: this.isMobile,
                    filterOptions: {
                        enabled: true
                    }
                },
                {
                    label: "Year Make",
                    field: "yearMake",
                    hidden: this.isMobile,
                    filterOptions: {
                        enabled: true
                    }
                },
                {
                    label: "NCD %",
                    field: "ncd",
                    hidden: this.isMobile,
                    filterOptions: {
                        enabled: true
                    }
                },
                {
                    label: "Source",
                    field: "source",
                    hidden: this.isMobile,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [
                            {
                                text: "Web",
                                value: "Web",
                            },
                            {
                                text: "Customer",
                                value: "Customer"
                            },
                            {
                                text: "Agent",
                                value: "Agent"
                            }
                        ]
                    }
                },
            ];
        },
    },
    methods: {
        onRowClick(e) {
            this.modal = e.row;
            this.$bvModal.show("customerDetails-modal");
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        async onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            await this.loadItems();
        },
        async onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            await this.loadItems();
        },
        async onSortChange(params) {
            this.updateParams({
                sort: params
            });
            await this.loadItems();
        },
        async onColumnFilter(params) {
            this.updateParams(params);
            await this.loadItems();
        },
        async loadItems() {
            this.isLoading = true;

            const skip = (this.serverParams.page - 1) * this.serverParams.perPage;
            const take = this.serverParams.perPage;
            const filter = this.serverParams.columnFilters;
            const sort = this.serverParams.sort;
            const { customers, totalCount } = await getCustomers(skip, take, sort, filter);
            this.columnData = customers;
            this.pageTotal = totalCount;
            this.isLoading = false;
        },
        onRowClick(e) {
            this.modal = e.row;
            this.$bvModal.show("customerDetails-modal");
        }
    },
};
</script>
